import {SubCategory} from '../models/sub-category';
import {useLanguageIndependentData} from './useLanguageIndependentData.hook';

export const useSubCategories=
    useLanguageIndependentData<SubCategory[]>('sub-categories');
